/**
 * @return {string}
 */
function UppercaseFilter(value) {
  return value?.toUpperCase() || value
}

export default UppercaseFilter
export { UppercaseFilter }
